<template>
  <div class="toGis">
    <!-- toGis -->
  </div>
</template>

<script>
export default {
  name: 'toGis',
  created() {
    let timeStamp = new Date().getTime();

    if (process.env.NODE_ENV === 'development') {
      window.open(
        'http://10.1.2.25:8003/szwygis/?id=bc733ed0-26ba-44e4-909f-047a97f9c538&time=' +
          timeStamp
      );
    } else if (process.env.NODE_ENV === 'production') {
      window.open(
        'https://zjj.sz.gov.cn/szwygis/?id=48203ef6-d9f7-420e-907c-ea52f2b16f23&time=' +
          timeStamp
      );
    }

    this.$router.go(-1);
  },
};
</script>

<style>
</style>
